<template>
  <div class="page-body v-setting-application">
    <b-row no-gutters>
      <b-col md="12">
        <b-card class="data-card text-right">
          <b-card-header class="text-right">
            تنظیمات اپلیکیشن موبایل
          </b-card-header>
          <template v-if="configs.loading">
            <div class="p-3">
              <BaseLoading :size="30" :border-width="3" />
            </div>
          </template>
          <template v-else>
            <b-card-body>
              <b-row class="mb-3">
                <b-col :cols="2"> نسخه آپدیت پیشنهادی </b-col>
                <b-col :cols="9">
                  <span class="font-weight-bold">
                    {{ configs.data.recommend }}
                  </span>
                </b-col>
              </b-row>
              <b-row>
                <b-col :cols="2"> نسخه آپدیت الزامی </b-col>
                <b-col :cols="9">
                  <span class="font-weight-bold">
                    {{ configs.data.force }}
                  </span>
                </b-col>
              </b-row>
            </b-card-body>
            <b-card-footer>
              <b-button
                variant="primary"
                @click="$bvModal.show('modal-update')"
              >
                ویرایش
              </b-button>
            </b-card-footer>
          </template>
        </b-card>
      </b-col>
    </b-row>
    <b-modal :hide-footer="true" id="modal-update" title="ویرایش تنظیمات">
      <b-row no-gutters>
        <b-col md="12">
          <b-card class="data-card text-right">
            <b-card-body>
              <b-row class="mb-3">
                <b-col :cols="12">
                  <label for=""> نسخه آپدیت پیشنهادی </label>
                  <b-input v-model="configs.data.recommend" />
                </b-col>
              </b-row>
              <b-row>
                <b-col :cols="12">
                  <label for=""> نسخه آپدیت الزامی </label>
                  <b-input v-model="configs.data.force" />
                </b-col>
              </b-row>
            </b-card-body>
            <b-card-footer>
              <base-button
                :disabled="configs.updateLoading"
                :loading="configs.updateLoading"
                type="primary"
                @click="updateConfig"
              >
                ذخیره
              </base-button>
            </b-card-footer>
          </b-card>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { getConfigs, updateConfigs } from "@/httpservices/ConfigManagement";
import Swal from "sweetalert2";
import BaseLoading from "@/components/BaseLoading";

export default {
  name: "SettingApplication",
  components: { BaseLoading },
  data() {
    return {
      configs: {
        loading: true,
        updateLoading: false,
        data: {
          recommend: "",
          force: "",
        },
      },
    };
  },

  methods: {
    async fetchData() {
      this.configs.loading = true;
      try {
        const res = (await getConfigs()).data;
        console.log({ res });
        this.configs.data = {
          ...this.configs.data,
          ...res.data,
        };
      } catch (e) {
        console.log(e);
      }
      this.configs.loading = false;
    },

    async updateConfig() {
      this.configs.updateLoading = true;
      try {
        await updateConfigs(this.configs.data);
        await Swal.fire({
          title: "با موفق اپدیت شد.",
          icon: "success",
        });
      } catch (e) {
        console.log({ e });
      }
      this.configs.updateLoading = false;
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style>
.modal-body {
  text-align: right;
  direction: rtl;
}

.modal-header .close {
  padding: 0;
  margin: 0;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
